import { render, staticRenderFns } from "./TermsFinancialAlertsLGT.vue?vue&type=template&id=6f9f08e3&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports